import { render, staticRenderFns } from "./Individual.vue?vue&type=template&id=adbe3544&"
import script from "./Individual.vue?vue&type=script&lang=ts&"
export * from "./Individual.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports